export function formatHour (value) {
  if(value<=0){
    return 0;
  }
  const hours = Math.trunc(value);
  let minutes = 60 * (value - hours);
  minutes = minutes < 1 ? 0 : minutes.toFixed()
  if(hours<=0 && minutes<=0){
    return 0
  }
  return `${hours}h${minutes}m`
}
